export default {
  rows: (state) => state.rows,
  row: (state) => state.row,
};
